import { styled } from "@mui/material/styles";
import { Grid, Select as MuiSelect } from "@mui/material";

export const Container = styled(Grid)({
  display: "flex",
  alignItems: "center",
  gap: "20px",
  margin: "6px 0",
});

export const Select = styled(MuiSelect, {
  shouldForwardProp: (prop) => prop !== "smallerInputStyles" && prop !== "width",
})<{ smallerInputStyles?: boolean; width?: number }>(
  {
    width: "80px",
  },
  ({ smallerInputStyles, width }) => ({
    ...(width && { width: `${width}px` }),
    ...(smallerInputStyles && {
      "& > .MuiSelect-select": { padding: "10px 14px 8px" },
    }),
  })
);
